import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import LandingPage from "./pages/LandingPage";
import PreviewPage from "./pages/PreviewPage";
import ReportPage from "./pages/ReportPage";
import SuccessPage from "./pages/SuccessPage";
import ThankYouPage from "./pages/ThankYouPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster 
          position="top-right" 
          theme="dark"
          toastOptions={{
            style: {
              background: '#000815',
              border: '1px solid rgba(0, 212, 255, 0.3)',
              color: '#F0F0F0',
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/preview/:caseId" element={<PreviewPage />} />
            <Route path="/thankyou/:caseId" element={<ThankYouPage />} />
            <Route path="/thankyou" element={<ThankYouPage />} />
            <Route path="/report/:caseId" element={<ReportPage />} />
            <Route path="/r/:caseId" element={<ReportPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <WhatsAppFloat />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
